// modules/ReturnButton.js
import React            from 'react';
import Arrow      from '../images/arrow';

class ReturnButton extends React.Component {

	searchScroll(){
		document.querySelector("#LFSS-Search").scrollIntoView({behavior: "smooth"});
	}

	render() {
		if(this.props.displaysearchbutton === true) {
			return (
				<div className="LFSS-Return" onClick={this.searchScroll}><Arrow />&nbsp; &nbsp;return to land search </div>
			);
		}
		else {
			return null;
		}
	}
}

export default ReturnButton;


/** WEBPACK FOOTER **
 ** ./src/modules/common/ReturnButton.js
 **/